import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'


Vue.config.productionTip = false
Vue.config.devtools = true


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

function skipElement(params){
    // console.log("elemento skippato");
  params.web_worker.postMessage(["skipElement"]);
}

function resetTimer(time, params){
  params.web_worker.postMessage(["resetTimer",time]);
    // console.log("timer resettato");
}

//funzione per mostrare il messaggio di errore
function showErrorMessage(){
  var errorMessage = document.getElementById("configurationErrorMessage");
  errorMessage.style.display = "block";
}

//funzione per nascondere il messaggio di errore
function hideErrorMessage(){
  var errorMessage = document.getElementById("configurationErrorMessage");
  errorMessage.style.display = "none";
}

//funzione per mostrare il messaggio di errore internet
function showInternetErrorMessage(){
  var internetErrorMessage = document.getElementById("internetErrorMessage");
  internetErrorMessage.style.display = "block";
}

//funzione per nascondere il messaggio di errore internet
function hideInternetErrorMessage(){
  var internetErrorMessage = document.getElementById("internetErrorMessage");
  internetErrorMessage.style.display = "none";
}


export {hideErrorMessage, hideInternetErrorMessage, resetTimer, skipElement, showErrorMessage, showInternetErrorMessage}
